import { Capacitor } from "@capacitor/core";
import { i18n } from "@/i18n";

export default {
  path: "/login",
  name: "loginLayout",
  component: () => import(/* webpackChunkName: "login" */ "@/views/Login/LayoutView.vue"),
  redirect: { name: "Login" },
  meta: {
    authRequired: false,
    title: i18n.global.t("page.login"),
  },
  children: [
    {
      path: "",
      name: "Login",
      component:
        Capacitor.getPlatform() === "web" || process.env.VUE_APP_API_PLATFORM_DOMAIN
          ? () => import(/* webpackChunkName: "login" */ "@/views/Login/WebLoginView.vue")
          : () => import(/* webpackChunkName: "login" */ "@/views/Login/MobileLoginView.vue"),
      meta: {
        authRequired: false,
        title: i18n.global.t("page.login"),
      },
    },
    {
      path: "reset-password",
      name: "loginResetPassword",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login/ResetPasswordView.vue"),
      meta: {
        authRequired: false,
        title: i18n.global.t("page.reset_password"),
      },
    },
    {
      path: "new-password/:hash",
      name: "loginNewPassword",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login/NewPasswordView.vue"),
      meta: {
        authRequired: false,
        title: i18n.global.t("page.new_password"),
      },
    },
    {
      path: "switch",
      name: "loginSwitch",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login/SwitchView.vue"),
      meta: {
        authRequired: false,
        title: i18n.global.t("page.switch"),
      },
    },
    {
      path: "saml",
      name: "loginSSO",
      component: () => import(/* webpackChunkName: "login" */ "@/views/Login/SSOLoginView.vue"),
      meta: {
        authRequired: false,
        title: i18n.global.t("page.switch"),
      },
    },
  ],
};
